<div
  *ngIf="visible"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
  role="dialog"
  aria-labelledby="job-offer-modal-title"
  aria-modal="true"
>
  <!-- Modal container -->
  <div class="relative w-full max-w-5xl bg-white rounded-lg border border-neutral-base shadow-lg overflow-hidden">

    <!-- Header -->
    <div class="flex justify-between items-center border-b border-neutral-base p-4">
      <h2 id="job-offer-modal-title" class="c-h2 flex-1 text-center mt-4">
        Detalle de la oferta
      </h2>
      <button
        (click)="closeDialog()"
        aria-label="Cerrar la ventana emergente"
        class="text-neutral-dark hover:text-neutral-base text-xl font-bold"
      >
        ✕
      </button>
    </div>

    <!-- Body -->
    <div class="p-6 space-y-6 text-neutral-dark">

      <!-- Identificación y proveedor -->
      <div class="grid grid-cols-2 gap-4">
        <p><strong>Identificador de la oferta:</strong> {{ jobOffer?.jobofferId || '-' }}</p>
        <p><strong>Código de proveedor:</strong> {{ jobOffer?.providerCode || '-' }}</p>
        <p><strong>Oferta validada:</strong> {{ jobOffer?.oferta_validada ? 'Sí' : 'No' }}</p>
        <p><strong>Idoneidad:</strong> {{ capitalizeFirstLetter(jobOffer?.idoneidad || '-' )}}</p>
      </div>

      <!-- Datos de la empresa -->
      <div class="space-y-1" 
          *ngIf="jobOffer?.providerCode === 'WISO' || jobOffer.datos_completos?.joboffer_proposal_validated === true">
        <p class="font-semibold">Datos de la empresa</p>
        <div class="grid grid-cols-2 gap-4">
          <p><strong>Nombre:</strong> {{ jobOffer?.datos_empresa?.nombre_empresa || '-' }}</p>
          <p><strong>NIF:</strong> {{ jobOffer?.datos_empresa?.nif || '-' }}</p>
        </div>
      </div>

      <!-- Puesto de trabajo -->
      <div class="space-y-1">
        <p class="font-semibold">Puesto de trabajo</p>
        <div class="grid grid-cols-2 gap-4">
          <p><strong>Nombre:</strong> {{ jobOffer?.datos_puesto_trabajo?.nombre_puesto || '-' }}</p>
          <p><strong>Municipio:</strong> {{ jobOffer?.datos_puesto_trabajo?.municipio || '-' }}</p>
          <p><strong>Provincia:</strong> {{ jobOffer?.datos_puesto_trabajo?.provincia || '-' }}</p>
          <p><strong>Tipo de oferta:</strong> {{ jobOffer?.datos_completos?.job_position_data?.job_position_data_offer_type || '-' }}</p>
          <p><strong>Posiciones a cubrir:</strong> {{ jobOffer?.datos_completos?.job_position_data?.job_position_data_positions_to_fill || '-' }}</p>
          <p><strong>Candidatos:</strong> {{ jobOffer?.datos_completos?.job_position_data?.job_position_data_candidates || '-' }}</p>
        </div>
      </div>

      <!-- Condiciones laborales -->
      <div class="space-y-1">
        <p class="font-semibold">Condiciones laborales</p>
        <div class="grid grid-cols-2 gap-4">
          <p><strong>Tipo de contrato:</strong> {{ jobOffer?.datos_completos?.hiring_data?.hiring_data_contract_type || '-' }}</p>
          <p><strong>Jornada:</strong> {{ jobOffer?.datos_completos?.hiring_data?.hiring_data_working_day || '-' }}</p>
          <p><strong>Horas semanales:</strong> {{ jobOffer?.datos_completos?.hiring_data?.hiring_data_weekly_hours || '-' }}</p>
          <p><strong>Horario:</strong> {{ jobOffer?.datos_completos?.hiring_data?.hiring_data_working_hours || '-' }}</p>
        </div>
      </div>

      <!-- Justificación -->
      <div *ngIf="seccionesJustificacion" class="space-y-2">
         <p *ngIf="seccionesJustificacion['OBLIGATORIOS']">
          <strong>Obligatorios: </strong>
          <ng-container *ngFor="let line of seccionesJustificacion['OBLIGATORIOS'].split('\n'); let i = index">
            <ng-container *ngIf="i > 0"><br></ng-container>{{ line }}
          </ng-container>
        </p>
        
        <p *ngIf="seccionesJustificacion['EXPERIENCIA']">
          <strong>Experiencia: </strong>
          <ng-container *ngFor="let line of seccionesJustificacion['EXPERIENCIA'].split('\n'); let i = index">
            <ng-container *ngIf="i > 0"><br></ng-container>{{ line }}
          </ng-container>
        </p>

        <p *ngIf="seccionesJustificacion['FORMACIÓN']">
          <strong>Formación: </strong>
          <ng-container *ngFor="let line of seccionesJustificacion['FORMACIÓN'].split('\n'); let i = index">
            <ng-container *ngIf="i > 0"><br></ng-container>{{ line }}
          </ng-container>
        </p>

         <p *ngIf="seccionesJustificacion['COMPETENCIAS']">
          <strong>Competencias: </strong>
          <ng-container *ngFor="let line of seccionesJustificacion['COMPETENCIAS'].split('\n'); let i = index">
            <ng-container *ngIf="i > 0"><br></ng-container>{{ line }}
          </ng-container>
        </p>

        <p *ngIf="seccionesJustificacion['VALORACIÓN GENERAL']">
          <strong>Valoración general: </strong>
          <ng-container *ngFor="let line of seccionesJustificacion['VALORACIÓN GENERAL'].split('\n'); let i = index">
            <ng-container *ngIf="i > 0"><br></ng-container>{{ line }}
          </ng-container>
        </p>
      </div>
    </div>

    <!-- Footer con botón Desy -->
    <div class="border-t border-neutral-base p-4 text-right">
      <desy-button
        [text]="'Cerrar detalle'"
        [classes]="'c-button--primary w-58'"
        (clickEvent)="closeDialog()">
      </desy-button>
    </div>
  </div>
</div>
